/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Observable, Subject, ReplaySubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class WebsocketHandlerService {
  private socket?: WebSocket;
  private isConnected = false;
  private specialChar = '\u001e';
  private accessToken = '';
  private eventSubjects: Map<string, Subject<any>> = new Map();
  private connectionReady$ = new ReplaySubject<void>(1); // ✅ Emite cuando socket está listo

  connect(token: string): void {
    if (this.isConnected || this.socket) return;

    this.accessToken = token;
    this.socket = new WebSocket(
      `${environment.socketUrl}hub?access_token=${token}`,
    );

    this.socket.addEventListener('open', () => {
      this.isConnected = true;

      const handshake =
        JSON.stringify({ protocol: 'json', version: 1 }) + this.specialChar;

      if (this.socket?.readyState === WebSocket.OPEN) {
        this.socket.send(handshake);
        this.connectionReady$.next(); // ✅ Marca como listo
      }
    });

    this.socket.addEventListener('message', event => {
      const data = event.data;
      if (data.includes(this.specialChar)) {
        const payload = data.replace(this.specialChar, '');
        const result = JSON.parse(payload);

        if (result?.type === 1 && result?.target) {
          const subject = this.eventSubjects.get(result.target);
          if (subject) {
            subject.next(result.arguments);
          }
        }
      }
    });

    this.socket.addEventListener('close', () => {
      this.isConnected = false;
      this.cleanup();
    });
  }

  listen<T>(eventName: string): Observable<T> {
    if (!this.eventSubjects.has(eventName)) {
      this.eventSubjects.set(eventName, new Subject<T>());
    }
    return this.eventSubjects.get(eventName)!.asObservable();
  }

  send(method: string, args: any | [string]): void {
    this.connectionReady$.subscribe(() => {
      if (this.socket?.readyState === WebSocket.OPEN) {
        const message =
          JSON.stringify({
            type: 1,
            target: method,
            arguments: args,
          }) + this.specialChar;

        this.socket.send(message);
      } else {
        console.warn('WebSocket not open yet');
      }
    });
  }

  disconnect(): void {
    this.socket?.close();
    this.socket = undefined;
    this.isConnected = false;
    this.cleanup();
  }

  private cleanup(): void {
    this.eventSubjects.forEach(subject => subject.complete());
    this.eventSubjects.clear();
    this.connectionReady$ = new ReplaySubject<void>(1); // Reset conexión
  }
}
